import script from "./WhatsAppInteractionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppInteractionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppInteractionPanel.vue?vue&type=style&index=0&id=0cc3c335&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc3c335"]])

export default __exports__